//The contents of this file have been generated automatically. Do not edit this file.

import * as t from 'io-ts';
import { isRight } from 'fp-ts/lib/Either';
import { fetchGeneralRaw, FetchGeneralRawResponseType } from 'src_common/common/fetch';
import { ApiTimeLog } from 'src_common/server/webDriver/logFormat';


export interface ParamsType {
    requestBody: {
        amount: number;
        billingInfo: {
            addressLine1?: null | undefined | string;
            addressLine2?: null | undefined | string;
            city?: null | undefined | string;
            country?: null | undefined | string;
            email?: null | undefined | string;
            number?: null | undefined | string;
            postCode?: null | undefined | string;
            prefix?: null | undefined | string;
        };
        channel: string;
        displayedReason?: null | undefined | string;
        paymentMethod?: null | undefined | {
            expires?: null | undefined | string;
            id?: null | undefined | string;
            lastUsedAt?: null | undefined | string;
            name?: null | undefined | string;
            number?: null | undefined | string;
            provider: string;
            providerReference?: null | undefined | string;
            subtype?: null | undefined | string;
            type: string;
        };
        securityCode?: null | undefined | string;
        status: 'initiated' | 'paid' | 'failed' | 'rejected';
        tags?: null | undefined | {
            accountAdjustment?: null | undefined | boolean;
            adjustmentType?: null | undefined | string;
            tradingAdjustment?: null | undefined | boolean;
        };
    };
}


const createGuard = <A>(code: number, decoder: t.Type<A, A, unknown>): ((data: unknown) => A) => {
    return (data: unknown): A => {
        const decodeResult = decoder.decode(data);
        if (isRight(decodeResult)) {
            return decodeResult.right;
        }
        throw Error(`Response decoding error /api-proxy/customer/deposit -> post -> ${code}`);
    };
};

export const Response200IO = t.union([t.interface({
    errors: t.array(t.interface({
        code: t.string,
        debugDetails: t.union([t.null, t.undefined, t.string]),
        field: t.string,
        resource: t.string,
    })),
    status: t.literal('422'),
    type: t.literal('RealexErrorResponse'),
}), t.interface({
    bodyJson: t.interface({
        accountId: t.union([t.null, t.undefined, t.string]),
        amount: t.number,
        channel: t.union([t.null, t.undefined, t.string]),
        createdAt: t.union([t.null, t.undefined, t.string]),
        currency: t.string,
        customerName: t.union([t.null, t.undefined, t.string]),
        displayedReason: t.union([t.null, t.undefined, t.string]),
        finalizedAt: t.union([t.null, t.undefined, t.string]),
        id: t.number,
        internalReason: t.union([t.null, t.undefined, t.string]),
        mockUrl: t.union([t.null, t.undefined, t.string]),
        paymentForm: t.union([t.null, t.undefined, t.interface({
            formActionUrl: t.string,
            formData: t.record(t.string, t.string),
            type: t.string,
        })]),
        paymentMethod: t.union([t.null, t.undefined, t.interface({
            expires: t.union([t.null, t.undefined, t.string]),
            id: t.union([t.null, t.undefined, t.string]),
            lastUsedAt: t.union([t.null, t.undefined, t.string]),
            name: t.union([t.null, t.undefined, t.string]),
            number: t.union([t.null, t.undefined, t.string]),
            provider: t.string,
            providerReference: t.union([t.null, t.undefined, t.string]),
            subtype: t.union([t.null, t.undefined, t.string]),
            type: t.string,
        })]),
        paymentResponse: t.union([t.null, t.undefined, t.string]),
        reason: t.union([t.null, t.undefined, t.string]),
        secureTradingPaymentForm: t.union([t.null, t.undefined, t.interface({
            formActionUrl: t.string,
            formData: t.record(t.string, t.array(t.string)),
            type: t.string,
        })]),
        status: t.union([t.literal('initiated'), t.literal('paid'), t.literal('failed'), t.literal('rejected')]),
        tags: t.union([t.null, t.undefined, t.interface({
            accountAdjustment: t.union([t.null, t.undefined, t.boolean]),
            adjustmentType: t.union([t.null, t.undefined, t.string]),
            tradingAdjustment: t.union([t.null, t.undefined, t.boolean]),
        })]),
        threeDeSecureChallengeData: t.union([t.null, t.undefined, t.string]),
        type: t.union([t.null, t.undefined, t.string]),
        updatedAt: t.union([t.null, t.undefined, t.string]),
        url: t.string,
        walletTransactionUrl: t.string,
    }),
    status: t.literal('200'),
    type: t.literal('RealexSuccessResponse'),
})]);
export type Response200Type = {
    errors: Array<{
        code: string;
        debugDetails?: null | undefined | string;
        field: string;
        resource: string;
    }>;
    status: '422';
    type: 'RealexErrorResponse';
} | {
    bodyJson: {
        accountId?: null | undefined | string;
        amount: number;
        channel?: null | undefined | string;
        createdAt?: null | undefined | string;
        currency: string;
        customerName?: null | undefined | string;
        displayedReason?: null | undefined | string;
        finalizedAt?: null | undefined | string;
        id: number;
        internalReason?: null | undefined | string;
        mockUrl?: null | undefined | string;
        paymentForm?: null | undefined | {
            formActionUrl: string;
            formData: Record<string, string>;
            type: string;
        };
        paymentMethod?: null | undefined | {
            expires?: null | undefined | string;
            id?: null | undefined | string;
            lastUsedAt?: null | undefined | string;
            name?: null | undefined | string;
            number?: null | undefined | string;
            provider: string;
            providerReference?: null | undefined | string;
            subtype?: null | undefined | string;
            type: string;
        };
        paymentResponse?: null | undefined | string;
        reason?: null | undefined | string;
        secureTradingPaymentForm?: null | undefined | {
            formActionUrl: string;
            formData: Record<string, Array<string>>;
            type: string;
        };
        status: 'initiated' | 'paid' | 'failed' | 'rejected';
        tags?: null | undefined | {
            accountAdjustment?: null | undefined | boolean;
            adjustmentType?: null | undefined | string;
            tradingAdjustment?: null | undefined | boolean;
        };
        threeDeSecureChallengeData?: null | undefined | string;
        type?: null | undefined | string;
        updatedAt?: null | undefined | string;
        url: string;
        walletTransactionUrl: string;
    };
    status: '200';
    type: 'RealexSuccessResponse';
};
export const decodeResponse200 = createGuard(200, Response200IO);

export const Response400IO = t.string;
export type Response400Type = string;
export const decodeResponse400 = createGuard(400, Response400IO);

export const Response401IO = t.string;
export type Response401Type = string;
export const decodeResponse401 = createGuard(401, Response401IO);

export const Response500IO = t.string;
export type Response500Type = string;
export const decodeResponse500 = createGuard(500, Response500IO);



type ExtraHeadersType = Record<string, string>


/**
 * @deprecated - Please use this method "openapiProxyCustomerDepositRequest"
 */
export const openapi_proxy_customer_deposit = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<FetchGeneralRawResponseType> => {
    
        
    const query = '';
    const url = `${api_url}/api-proxy/customer/deposit${query}`;
    
    const method = 'POST';
    const paramsFetch = {
        url,
        body: params.requestBody,
        backendToken,
        timeout: api_timeout,
        extraHeaders,
    };

    const apiTime = ApiTimeLog.createWithProcessEnv(method, url);
    const response = await fetchGeneralRaw(method, paramsFetch);
    apiTime.show(response.status);
    return response;
};


export type OpenapiProxyCustomerDepositParamsType = ParamsType;

export type OpenapiProxyCustomerDepositResponseType = {
    status: 200;
    body: Response200Type;
} | {
    status: 400;
    body: Response400Type;
} | {
    status: 401;
    body: Response401Type;
} | {
    status: 500;
    body: Response500Type;
};

export type OpenapiProxyCustomerDepositResponse200Type = Response200Type;

export const openapiProxyCustomerDepositRequest = async (api_url: string, api_timeout: number, backendToken: string, params: ParamsType, extraHeaders?: ExtraHeadersType): Promise<OpenapiProxyCustomerDepositResponseType> => {
    const response = await openapi_proxy_customer_deposit(api_url, api_timeout, backendToken, params, extraHeaders);
    const { status, body } = response;

    let json = null;

    try {
        json = JSON.parse(body);
    } catch (_err) {
        console.warn(`Http status ${status} - json was expected`);
        json = {};
    }
    
    if (status === 200) {
        return { status: 200, body: decodeResponse200(json) };
    }

    if (status === 400) {
        return { status: 400, body: decodeResponse400(json) };
    }

    if (status === 401) {
        return { status: 401, body: decodeResponse401(json) };
    }

    if (status === 500) {
        return { status: 500, body: decodeResponse500(json) };
    }

    throw new Error(`openapiProxyCustomerDepositRequest - unhandled response ${response.status}`);
};

